import * as _DE$ from './lib/datum-either';
export { _DE$ as DE$ };